import { isNotDefined } from '../../util/isEmpty'
import { type ReportColumnDefinition } from './column'

type ReportColumnIdentity = Pick<ReportColumnDefinition, 'value' | 'aliases'>

export function canonicalizeReportColumnValue(value: string, columns: ReportColumnIdentity[]): string | undefined {
  const direct = columns.find((column) => column.value === value)
  if (direct) return direct.value
  return columns.find((column) => column.aliases?.includes(value))?.value
}

export function resolveReportColumnValues(values: string[], columns: ReportColumnIdentity[]): string[] {
  return values.flatMap((value) => {
    const resolved = canonicalizeReportColumnValue(value, columns)
    if (isNotDefined(resolved)) return []
    return [resolved]
  })
}
